import { gql } from 'graphql-request';

export const RedeemGiftCard = gql`
  mutation redeemGiftCard($input: RedeemGiftCardInput!) {
    redeemGiftCard(input: $input) {
      id
      redeemed
    }
  }
`;
